import { reactive, defineComponent, h, render, defineAsyncComponent, nextTick } from 'vue';

const PopupPayment = defineAsyncComponent(() =>
  import('@martyrs/src/modules/payments/views/components/blocks/PopupPayment.vue')
);

const state = reactive({
  shouldRender: false,
  visible: false,
  amount: null,
  currency: 'RUB',
  description: '',
  mode: 'payment', // 'payment' | 'subscription' | 'topup'
  planId: null,
  metadata: {},
  resolve: null,
  reject: null,
});

export function showPayment({
  amount = null,
  currency = 'RUB',
  description = '',
  mode = 'payment',
  planId = null,
  metadata = {},
} = {}) {
  return new Promise((res, rej) => {
    state.resolve = res;
    state.reject = rej;
    state.amount = amount;
    state.currency = currency;
    state.description = description;
    state.mode = mode;
    state.planId = planId;
    state.metadata = metadata;
    state.shouldRender = true;
    nextTick(() => { state.visible = true; });
  });
}

export function closePayment(result = null) {
  state.visible = false;
  state.resolve?.(result);
  state.resolve = state.reject = null;
}

export function cancelPayment() {
  state.visible = false;
  state.reject?.(new Error('Payment cancelled'));
  state.resolve = state.reject = null;
}

function onAfterLeave() {
  state.shouldRender = false;
}

const PaymentDialogHost = defineComponent({
  name: 'PaymentDialogHost',
  setup() {
    return () => {
      if (!state.shouldRender) return null;

      return h(PopupPayment, {
        paymentState: state,
        closePayment,
        'onClose-popup': cancelPayment,
        'onAfter-leave': onAfterLeave,
      });
    };
  },
});

export default {
  install(app) {
    app.config.globalProperties.$payment = showPayment;
    app.config.globalProperties.$showPayment = showPayment;

    if (typeof window !== 'undefined' && typeof document !== 'undefined') {
      const container = document.createElement('div');
      container.id = 'payment-dialog-host';
      document.body.appendChild(container);

      const vnode = h(PaymentDialogHost);
      vnode.appContext = app._context;
      render(vnode, container);
    }
  },
};
